export default "__VITE_ASSET__DUp7v5hY__"